import { createClient } from '@supabase/supabase-js'

import type { Database, Rpc, Table } from '@/types/supabase'


export const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? `http://${window.location.hostname}:54321`
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'

const MUTATION_METHODS = new Set(['POST', 'PATCH', 'DELETE', 'PUT'])

const RPC_TABLE_MAPPING: Partial<Record<Rpc, Table[]>> = {
  accept_connection_request: ['connections', 'connection_requests'],
  publish_car: ['cars', 'car_drafts'],
  mark_all_companies_as_read: ['companies_read'],
  mark_all_cars_as_read: ['cars_read'],
  remove_user_role: ['users_metadata'],
  add_user_role: ['users_metadata'],
  delete_user: ['users', 'signups', 'users_metadata'],
  delete_own_account: ['users']
}

let mutationCallback: ((table: Table) => void) | null = null

export function setMutationCallback(cb: (table: Table) => void): void {
  mutationCallback = cb
}

const supabaseFetch: typeof fetch = async (input, init) => {
  const response = await globalThis.fetch(input, init)

  if (mutationCallback && init?.method && MUTATION_METHODS.has(init.method) && response.ok) {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input)
    const restPathMatch = url.match(/\/rest\/v1\/(.+?)(?:\?|$)/)
    if (restPathMatch) {
      const path = restPathMatch[1]
      if (path.startsWith('rpc/')) {
        const tables = RPC_TABLE_MAPPING[path.slice(4) as Rpc]
        tables?.forEach(t => mutationCallback!(t))
      } else {
        mutationCallback(path as Table)
      }
    }
  }

  return response
}

export default createClient<Database>(supabaseUrl, supabaseAnonKey, {
  global: { fetch: supabaseFetch }
})
